import React, { useState, useEffect } from 'react'
import { EXDefaultImage } from "components/utils/DefaultImage";

function LandingImage(props) {

    const [imageSRC, setImage] = useState("");
    const [loaded, setLoaded] = useState(false);
    const [loadClass, setLoadClass] = useState("hidden");

    useEffect(() => {
        if (props.landing && props.landing.cover_url && props.landing.cover_url != "") {
            setImage(props.landing.cover_url)
        }
    }, [props.landing]);

    function onError() {
        setImage(EXDefaultImage)
        setLoaded(true)
        setLoadClass("")
    }

    function onLoad() {
        setLoadClass("")
        setLoaded(true)
    }


    return (
        <>
            <img className={"lazyload oi-w-full " + loadClass}
                alt={props.landing?.title}
                src={imageSRC}
                onLoad={onLoad}
                onError={onError}
            />
            {
                !loaded &&

                <div
                  className="lazyload oi-skeleton oi-skeleton--wave oi-w-full"
                  style={{ height: props.skeleton_height ? props.skeleton_height : 265 }}
                  aria-hidden
                />
            }
        </>
    );
}

export default LandingImage
